export const DEMO_LINKS_URL = '/admin/demo-links'
export const DEMO_LIST_TAB_KEYS = {
  ACTIVE: 'active',
  NOT_ACTIVE: 'notActive'
}
